const basketActions = document.querySelectorAll('.js-basket-actions')
const basketForm = document.getElementById('js-basket-form')

if (basketActions.length) {
  basketActions.forEach((action) => {
    const input = action.querySelector('input')
    input.addEventListener('change', () => {
      basketForm.submit()
    })

    const removeButton = action.querySelector('.basket-page__remove')
    if(removeButton) {
      removeButton.addEventListener('click', () => {
        input.value = 0
        basketForm.submit()
      })
    }

    const minusButton = action.querySelector(
      '.add-to-basket__amount-btn:first-of-type'
    )
    minusButton.addEventListener('click', () => {
      input.value = parseInt(input.value) - 1
      basketForm.submit()
    })

    const plusButton = action.querySelector(
      '.add-to-basket__amount-btn:last-of-type'
    )
    plusButton.addEventListener('click', () => {
      input.value = parseInt(input.value) + 1
      basketForm.submit()
    })
  })

  const country = document.getElementById('del_country_id')
  if (country) {
     if(!localStorage.getItem('country')) {
        country.options[0].selected = true
     }
    
     country.addEventListener('change', (e) => {
        localStorage.setItem('country', e.target.value)
      basketForm.submit()
    })
  }

  const pointInput = document.getElementById('use_points')
  const pointInputHidden = document.getElementById('use_points_hidden')
  const pointIndicator = document.getElementById('using_points')
  const pointWarning = document.getElementById('use_points_warning')
  if(pointInput) {
    
    pointInput.addEventListener('input', () => {
      pointIndicator.innerText = pointInput.value

      if(pointInput.value < 500) {
        pointWarning.style.display = 'block'
      } else {
        pointWarning.style.display = 'none'
      }
    })

    pointInput.addEventListener('change', () => {
      if(pointInput.value >= 500) {
        pointInputHidden.value = pointInput.value
        
        setTimeout(() => {
          basketForm.submit()
        }, 100)
      } else {
        if(pointInputHidden.value !== "0") {
          setTimeout(() => {
            basketForm.submit()
          }, 100)
        }
        pointInputHidden.value = 0
      }
    })
  }
}

const discountTriggers = document.querySelectorAll('.basket-page__discount-trigger')
  discountTriggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      trigger.classList.toggle('basket-page__discount-trigger--open')
      trigger.nextElementSibling.classList.toggle('basket-page__discount-content--open')
    })
  }
)
